module.exports = __webpack_public_path__ + "static/InvoicingAndAccounting-c86ac738dd8b6796a2f956b303a83bbb.svg";